import React, { useContext, useEffect, useState, useLayoutEffect } from "react";
import Accordian from "./Accordian/Accordian";
import { TaskListArrayData } from "../../Helpers/json/TaskListData";
import { Link, useNavigate } from "react-router-dom";
import {
  getTCNatureOfIssueStatus,
  GetTestCaseStatus,
  getDashboardData,
  GetDropDownList,
  getWorkPolicyWorkdayList,
  getBackDatedData,
  getEngagementForTestCases,
  getRequirementForTestCases,
  getTestCasesDashboard,
  getEngagementManagerForTestCases,
  getRMforEngagement,
  getEngForMgrRiskMitigationDashboard,
  getEngForRiskMitigationDashboard, //sangam
  getTicketTypeList, //sangam
} from "../../Helpers/API/APIEndPoints";
import { APICall } from "../../Helpers/API/APICalls";
import Accordian2 from "./Accordian/Accordian2";
import Accordian3 from "./Accordian/Accordian3";
import Accordian5 from "./Accordian/Accordian5";
import Accordian4 from "./Accordian/Accordian4";
import { format } from "date-fns";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import Bubble from "../../Layout/Bubble/Bubble";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField, Box, Autocomplete } from "@mui/material";

import SelectForm from "../../Components/SelectForm/SelectForm";
import { truncate } from "fs";
import moment from "moment";
import InputForm from "../../Components/InputForm/InputForm";
//sangam
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { TicketType, engagementStatusOptions } from "../../Common/CommonJson";
import Accordian6 from "./Accordian/Accordian6";
//
function Homescreen() {
  //sangam
  const [start, setStart] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentdataLength, setCurrentDataLength] = useState(0);
  const [loadMore, setLoadMore] = useState(false);

  //

  const [currentDate, setCurrentDate] = useState<Date | null>(new Date());
  const [backDateStatus, setBackDateStatus] = useState(false);
  const [resourceAllocatedOptions, setResourceAllocatedOptions] = useState<any>(
    []
  );
  const [employeeChanged, setEmployeeChanged] = useState(false);
  const [dashboardData, setDashboardData] = useState([]);
  const [futureDates, setFutureDates] = useState([]);
  const [calendarStatus, setCalendarStatus] = useState(false);
  const [totalReportedHours, settotalReportedHours] = useState(0);
  const [workdayList, setWorkdayList] = useState([]);
  const [taskStatusDropdown, setTaskStatusDropdown] = useState([]);
  const [ticketStatusDropdown, setTicketStatusDropdown] = useState([]);
  const [natureOfIssueDropdown, setNatureOfIssueDropdown] = useState([]);
  const [testcaseStatusDropdown, setTestcaseStatusDropdown] = useState([]);
  const [issueStatusDropdown, setIssueStatusDropdown] = useState([]);
  const [tcnatureOfIssueDropdown, setTCnatureOfIssueDropdown] = useState([]);
  const [totalReportedHoursToday, setTotalReportedHoursToday] = useState(0);
  const [checkWeekend, setCheckWeekend] = useState(false);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { EmployeeId, EmployeeWorkPolicyId, RoleId } = getContext();
  const [formError, setFormError] = useState("");
  const [Remark, setRemark] = useState("");
  const [env, setEnv] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
  );

  //Krishnam Upadhyay
  const defaultProps = {
    options: resourceAllocatedOptions,
    getOptionLabel: (option: any) => option.label,
  };
  //Yawar Ali 18-07-2023

  const [engDdForTc, setEngDdForTc] = useState<any>([]);
  const [riskEngDropDownOptions, setRiskEngDropDownOptions] = useState<any>([]);
  const [allRiskMitigationData, setAllRiskMitigationData] = useState<any>([]);
  const [riskEngValue, setRiskEngValue] = useState<any>([]);
  const [engValTc, setEngValTc] = useState<any>({
    value: 0,
    label: "Select Engagement",
  });
  const [reqDdForTc, setReqDdForTc] = useState<any>([]);
  const [riskMitigationData, setRiskMitigationData] = useState<any>([]);
  const [reqValTc, setReqValTc] = useState<any>({
    value: 0,
    label: "Select Requirement",
  });
  const [tcDashData, setTcDashData] = useState<any>([]);
  /*const [ddLoad, setDDLoad] = useState(0);*/
  //----------------------------------------------------

  const [resourceAllocated, setResourceAllocated] = useState<any>({
    value: Number(EmployeeId),
  });
  // const [assignedToOptions, setAssignedToOptions] = useState<any>(
  //   []
  // );
  const [employeeHide, setEmployeeHide] = useState(true);

  const RoleIdArray = RoleId.split(",");
  //sangam
  const [ticketTypeOptoins, setTicketTypeDropDown] = useState([]);

  //sangam
  const handleInfiniteScroll = async () => {
    try {
      // console.log("scrollheight", document.documentElement.scrollHeight);
      // console.log("innerheight", window.innerHeight);
      // console.log("scrollTop", document.documentElement.scrollTop);
      // console.log("calculatoin",window.innerHeight+document.documentElement.scrollTop , document.documentElement.scrollHeight, currentdataLength)

      // if(window.innerHeight+document.documentElement.scrollTop >=  (document.documentElement.scrollHeight)){

      if (tcDashData.length > 0 && totalCount > tcDashData.length) {
        setStart((prevstart) => prevstart + 10);
      }

      // }
    } catch (err) {
      //console.log(err);
    }
  };

  useEffect(() => {
    // window.addEventListener("scroll",handleInfiniteScroll);
    // return () => window.removeEventListener("scroll",handleInfiniteScroll);
    if (loadMore) {
      // setIsLoading(true);
      handleInfiniteScroll();
    }
  }, [loadMore]);

  useEffect(() => {
    setIsLoading(false);

    if (tcDashData.length == 0) {
      setTotalCount(0);
      setCurrentDataLength(0);
      setStart(0);
    }
    if (tcDashData[0] && tcDashData.length < tcDashData[0].totalCount) {
      tcDashData[0] && setTotalCount(tcDashData[0].totalCount);
      setCurrentDataLength((prev) => prev + tcDashData.length);

      setLoadMore(false);
    }
  }, [tcDashData]);

  useEffect(() => {
    (async () => {
      // await setIsLoading(true);
      const { data } = await APICall(getTestCasesDashboard, "POST", {
        EngagementId: engValTc.value,
        RequirementId: reqValTc.value,
        start: start, //sangam
      });

      if (data !== null && data.length > 0) {
        data.forEach((ele) => {
          ele.plannedStartDate = new Date(ele.plannedStartDate);
          ele.plannedEndDate = new Date(ele.plannedEndDate);

          ele.status = testcaseStatusDropdown.find(
            (element) => element.id === ele.status
          );
        });
        let finalArr: any = new Set();
        let first = [...data];
        first = first
          .filter(
            (ele) =>
              ele.plannedEndDate < new Date() ||
              ele.plannedEndDate === new Date()
          )
          .sort((a, b) => a.plannedEndDate - b.plannedEndDate);
        let second = [...data];
        second = second
          .filter(
            (ele) =>
              ele.plannedStartDate < new Date() ||
              ele.plannedStartDate.toDateString() === new Date().toDateString()
          )
          .sort((a, b) => a.plannedStartDate - b.plannedStartDate);
        let third = [...data];
        third = third
          .filter((ele) => ele.plannedStartDate > new Date())
          .sort((a, b) => a.plannedStartDate - b.plannedStartDate);

        let groupedFutureDates = groupArrayOfObjects(third, "plannedStartDate");

        groupedFutureDates = Object.values(groupedFutureDates);

        setFutureDates(groupedFutureDates);

        finalArr = new Set([...first, ...second]);
        finalArr = Array.from(finalArr);

        //  await setTotalCount(data[0].totalCount); //sangam
        //  await setCurrentDataLength(finalArr.length)//
        setTcDashData((prevArr) => [...prevArr, ...finalArr]); //sangam
      }
      setIsLoading(false);
    })();
  }, [start]);

  //

  //group by func
  function groupArrayOfObjects(list, key) {
    return list.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }
  const getTestCaseLabel = (dashboardData: any) => {
    let testCaseLabel = dashboardData.find((el) => el.rType === "TestCase");

    if (testCaseLabel === null || testCaseLabel === undefined) {
      return false;
    } else {
      return true;
    }
  };
  const getTaskTicketLabel = (dashboardData: any) => {
    let ticketLable = dashboardData.find((el) => el.rType === "Task");
    let taskLable = dashboardData.find((el) => el.rType === "Ticket");
    let ticketLableticketLableticketLable = dashboardData.find(
      (el) => el.rType === "TestCaseIssue"
    );

    if (
      (taskLable === null || taskLable === undefined) &&
      (ticketLable === null || ticketLable === undefined) &&
      (ticketLableticketLableticketLable === null ||
        ticketLableticketLableticketLable === undefined)
    ) {
      return false;
    } else {
      return true;
    }
  };

  const resourceApiCall = async () => {
    let postObject = {
      searchFor: "employee",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);

    if (data != undefined || data != null) {
      let employeeArray = [];
      await data.map((employee: any) => {
        let tempObj = {
          value: employee.id,
          label: employee.name,
          workPolicyID: employee.workPolicyId,
        };
        if (tempObj.value == resourceAllocated.value) {
          setResourceAllocated(tempObj);
        }
        employeeArray.push(tempObj);
      });
      setResourceAllocatedOptions(employeeArray);
    }
  };
  useEffect(() => {
    if (RoleIdArray.includes("3") || RoleIdArray.includes("8")) {
      resourceApiCall();
      setEmployeeHide(false);
    }
    (async () => {
      const { data } = await APICall(GetDropDownList, "post", {
        searchFor: "status",
        searchValue: 1,
      });
      if (data !== null) {
        if (data.length > 0) {
          setTaskStatusDropdown(data);
          //   [
          //     {
          //         "id": 1,
          //         "value": "Not Started",

          //     },
          //     {
          //         "id": 3,
          //         "value": "In Progress",

          //     },
          //     {
          //         "id": 4,
          //         "value": "On Hold",

          //     },
          //     {
          //         "id": 5,
          //         "value": "Completed",

          //     }
          // ]
        }
      }
    })();
    (async () => {
      const { data } = await APICall(getWorkPolicyWorkdayList, "POST", {
        workPolicyId: EmployeeWorkPolicyId,
      });
      if (data && data.length > 0) {
        let temp = [...data];
        temp = temp.filter((x) => x !== null);
        setWorkdayList(temp);
      }
    })();

    //sangam
    (async () => {
      const { data } = await APICall(getTicketTypeList, "POST", {});
      if (data && data.length > 0) {
        let tickettypetemp = [];
        await data.map((d) => {
          let tempObj = {
            value: d.ticketTypeId,
            label: d.name,
          };
          tickettypetemp.push(tempObj);
        });
        await setTicketTypeDropDown(tickettypetemp);
      }
    })();
    //
    (async () => {
      const { data } = await APICall(GetDropDownList, "post", {
        searchFor: "status",
        searchValue: 2,
      });
      if (data !== null) {
        if (data.length > 0) {
          setTicketStatusDropdown(data);
        }
      }
    })();

    (async () => {
      const { data } = await APICall(GetDropDownList, "post", {
        searchFor: "ticketType",
        searchValue: 1,
      });
      if (data !== null) {
        if (data.length > 0) {
          setNatureOfIssueDropdown(data);
        }
      }
    })();

    (async () => {
      const { data } = await APICall(getTCNatureOfIssueStatus, "post");
      setTCnatureOfIssueDropdown(data);
    })();

    (async () => {
      const { data } = await APICall(GetDropDownList, "post", {
        searchFor: "status",
        searchValue: 3,
      });
      if (data !== null) {
        if (data.length > 0) {
          setIssueStatusDropdown(data);
        }
      }
    })();

    //TestCaseStatus dropdown
    (async () => {
      const { data } = await APICall(GetTestCaseStatus, "post", {
        RoleId: 2,
      });
      setTestcaseStatusDropdown(data);
    })();

    // (async () => {
    //   let postObject = {
    //   searchFor: "employee",
    //   searchValue: 1,
    // };
    // const { data } = await APICall(GetDropDownList, "POST", postObject);

    // if (data != undefined || data != null) {
    //   let assignedToArray = [];
    //   await data.map((employee: any) => {
    //     let tempObj = {
    //       value: employee.id,
    //       label: employee.name,
    //     };
    //     assignedToArray.push(tempObj);
    //   });
    //   setAssignedToOptions(assignedToArray);
    // }
    // })();
    //Pinky for Manager Engagment Dropdown for Testcase 15 feb
    if (RoleIdArray.includes("3")) {
      (async () => {
        const { data } = await APICall(
          getEngagementManagerForTestCases,
          "post",
          {}
        );
        if (data !== null && data.length > 0) {
          let eng = data.map((element) => ({
            value: element.id,
            label: element.engagement,
          }));
          setEngDdForTc(eng);
        }
      })();
    } else {
      //added by yawar
      (async () => {
        const { data } = await APICall(getEngagementForTestCases, "post", {
          Id: EmployeeId,
        });
        if (data !== null && data.length > 0) {
          let eng = data.map((element) => ({
            value: element.id,
            label: element.engagement,
          }));
          setEngDdForTc(eng);
        }
      })();
    }
    //=========================
  }, []);

  useEffect(() => {
    // Added By Hetal
    if (RoleIdArray.includes("3")) {
      (async () => {
        const { data } = await APICall(
          getEngForMgrRiskMitigationDashboard,
          "post",
          {}
        );
        if (data !== null && data.length > 0) {
          let eng = data.map((element) => ({
            value: element.id,
            label: element.engagement,
          }));
          setRiskEngDropDownOptions(eng);
        }
      })();
    } else {
      (async () => {
        const { data } = await APICall(
          getEngForRiskMitigationDashboard,
          "post",
          {
            Id: EmployeeId,
          }
        );
        if (data !== null && data.length > 0) {
          let eng = data.map((element) => ({
            value: element.id,
            label: element.engagement,
          }));
          setRiskEngDropDownOptions(eng);
        }
      })();
    }
  }, []);

  useEffect(() => {
    // if (backDateStatus === false) {
    //   return;
    // }
    (async () => {
      const { data } = await APICall(GetDropDownList, "post", {
        searchFor: "status",
        searchValue: 1,
      });
      if (data !== null) {
        if (data.length > 0) {
          setTaskStatusDropdown(data);
          //   [
          //     {
          //         "id": 1,
          //         "value": "Not Started",

          //     },
          //     {
          //         "id": 3,
          //         "value": "In Progress",

          //     },
          //     {
          //         "id": 4,
          //         "value": "On Hold",

          //     },
          //     {
          //         "id": 5,
          //         "value": "Completed",

          //     }
          // ]
        }
      }
    })();
    (async () => {
      const { data } = await APICall(getWorkPolicyWorkdayList, "POST", {
        workPolicyId: resourceAllocated.workPolicyID,
      });
      if (data && data.length > 0) {
        let temp = [...data];
        temp = temp.filter((x) => x !== null);
        setWorkdayList(temp);
      }
    })();
    (async () => {
      const { data } = await APICall(GetDropDownList, "post", {
        searchFor: "status",
        searchValue: 2,
      });
      if (data !== null) {
        if (data.length > 0) {
          setTicketStatusDropdown(data);
        }
      }
    })();

    (async () => {
      const { data } = await APICall(GetDropDownList, "post", {
        searchFor: "ticketType",
        searchValue: 1,
      });
      if (data !== null) {
        if (data.length > 0) {
          setNatureOfIssueDropdown(data);
        }
      }
    })();

    (async () => {
      const { data } = await APICall(getTCNatureOfIssueStatus, "post");
      setTCnatureOfIssueDropdown(data);
    })();

    (async () => {
      const { data } = await APICall(GetDropDownList, "post", {
        searchFor: "status",
        searchValue: 3,
      });
      if (data !== null) {
        if (data.length > 0) {
          setIssueStatusDropdown(data);
        }
      }
    })();

    //  //TestCaseStatus dropdown
    //  (async () => {
    //   const { data } = await APICall(GetTestCaseStatus, "post"
    //   );
    //   if (data !== null) {
    //     if (data.length > 0) {
    //       setTestcaseStatusDropdown(data);
    //     }
    //   }
    // })();
    // //
  }, [currentDate, resourceAllocated]);

  useEffect(() => {
    if (
      ticketStatusDropdown.length !== 0 &&
      taskStatusDropdown.length !== 0 &&
      issueStatusDropdown.length !== 0 //Added by Yawar on 27/07
    )
      if (backDateStatus === true || employeeChanged === true) {
        //  console.log("inside if 1");
        /*added by yawar*/
        if (resourceAllocated.value === Number(EmployeeId)) {
          (async () => {
            const { data } = await APICall(getEngagementForTestCases, "post", {
              Id: EmployeeId,
            });
            if (data !== null && data.length > 0) {
              let eng = data.map((element) => ({
                value: element.id,
                label: element.engagement,
              }));
              setEngDdForTc(eng);
            }
          })();
        } else {
          setTcDashData([]);
          setReqDdForTc([]);
          setEngDdForTc([]);
          setEngValTc({ value: 0, label: "Select Engagement" });
          setReqValTc({ value: 0, label: "Select Requirement" });
        }
        //----------------------
        (async () => {
          showLoader();
          let { data } = await APICall(getBackDatedData, "Post", {
            userID: resourceAllocated.value,
            backDatedDate: moment(currentDate).format(moment.HTML5_FMT.DATE),
          });
          hideLoader();
          if (data !== null) {
            if (data.length > 0) {
              data.forEach((ele) => {
                ele.plannedStartDate = new Date(ele.plannedStartDate);
                ele.plannedEndDate = new Date(ele.plannedEndDate);

                if (ele.rType === "Task") {
                  ele.status = taskStatusDropdown.find(
                    (element) => element.id === ele.status
                  );
                }
                if (ele.rType === "Ticket") {
                  ele.status = ticketStatusDropdown.find(
                    (element) => element.id === ele.status
                  );
                  ele.ticketNatureOfIssue = natureOfIssueDropdown.find(
                    (element) => element.value === ele.ticketNatureOfIssue
                  );
                }
                // else if (ele.rType === "TestCase") {
                //   ele.status = testcaseStatusDropdown.find(
                //     (element) => element.id === ele.status
                //   );
                // }
                if (ele.rType === "TestCaseIssue") {
                  ele.status = issueStatusDropdown.find(
                    (element) => element.id === ele.status
                  );
                  ele.ticketNatureOfIssue = tcnatureOfIssueDropdown.find(
                    (element) => element.id === ele.ticketNatureOfIssue
                  );
                }
              });

              let finalArr: any = new Set();
              let first = [...data];
              first = first
                .filter(
                  (ele) =>
                    ele.plannedEndDate < new Date() ||
                    ele.plannedEndDate === new Date()
                )
                .sort((a, b) => a.plannedEndDate - b.plannedEndDate);
              let second = [...data];
              second = second
                .filter(
                  (ele) =>
                    ele.plannedStartDate < new Date() ||
                    ele.plannedStartDate.toDateString() ===
                      new Date().toDateString()
                )
                .sort((a, b) => a.plannedStartDate - b.plannedStartDate);
              let third = [...data];
              third = third
                .filter((ele) => ele.plannedStartDate > new Date())
                .sort((a, b) => a.plannedStartDate - b.plannedStartDate);
              // third.forEach((element) => {
              //   if (element.rType === "Task") new{
              //     // element.fStatus = 3;
              //     // // element.fnatureOfIssure = null;
              //     // // element.fLinkedTicket = null;
              //     // element.thoursSpent = "";
              //     // element.fRemarks = "";
              //   } else {
              //     element.fStatus = 3;
              //     element.fnatureOfIssure = null;
              //     element.fLinkedTicket = null;
              //     element.thoursSpent = "";
              //     element.fRemarks = "";
              //   }
              // });

              let groupedFutureDates = groupArrayOfObjects(
                third,
                "plannedStartDate"
              );

              groupedFutureDates = Object.values(groupedFutureDates);

              setFutureDates(groupedFutureDates);

              finalArr = new Set([...first, ...second]);
              finalArr = Array.from(finalArr);

              // finalArr.forEach((element) => {
              //   if (element.rType === "Task") {
              //     // element.fStatus = taskStatusDropdown.find(
              //     //   (ele) => ele.id === element.status
              //     // );
              //     // // element.fnatureOfIssure = null;
              //     // // element.fLinkedTicket = null;
              //     // element.thoursSpent = "";
              //     // element.fRemarks = "";
              //   } else {
              //     element.fStatus = ticketStatusDropdown.find(
              //       (ele) => ele.id === 6
              //     );
              //     element.ticketNatureOfIssue = natureOfIssueDropdown.find(
              //       (ele) => ele.value == element.ticketNatureOfIssue
              //     );
              //     element.fLinkedTicket = null;
              //     element.thoursSpent = "";
              //     element.fRemarks = "";
              //   }
              // });
              // Omkar P sorting based on status In Progress, Not started for Task, Ticket, Issue
              finalArr.sort((a, b) => {
                const customPriority: Record<string, number> = {
                  "Not Started": 1,
                  "In Progress": 2,
                  // Add other status priorities as needed
                };

                const getStatusPriority = (status: string): number => {
                  return customPriority[status] ?? Number.MAX_SAFE_INTEGER;
                };

                const priorityA = getStatusPriority(a.status.value);
                const priorityB = getStatusPriority(b.status.value);

                return priorityA - priorityB;
              });

              setDashboardData(finalArr);
            }
          }
        })();
      } else {
        // console.log("else");
        (async () => {
          showLoader();
          let { data } = await APICall(getDashboardData, "Post", {
            Userid: EmployeeId,
          });
          hideLoader();
          if (data !== null) {
            if (data.length > 0) {
              data.forEach((ele) => {
                ele.plannedStartDate = new Date(ele.plannedStartDate);
                ele.plannedEndDate = new Date(ele.plannedEndDate);

                if (ele.rType === "Task") {
                  ele.status = taskStatusDropdown.find(
                    (element) => element.id === ele.status
                  );
                }
                // else
                if (ele.rType === "Ticket") {
                  ele.status = ticketStatusDropdown.find(
                    (element) => element.id === ele.status
                  );
                  ele.ticketNatureOfIssue = natureOfIssueDropdown.find(
                    (element) => element.value === ele.ticketNatureOfIssue
                  );
                }
                //else if (ele.rType === "TestCase") {
                //   ele.status = testcaseStatusDropdown.find(
                //     (element) => element.id === ele.status
                //   );
                // }
                //else {
                if (ele.rType === "TestCaseIssue") {
                  ele.status = issueStatusDropdown.find(
                    (element) => element.id === ele.status
                  );
                  ele.ticketNatureOfIssue = tcnatureOfIssueDropdown.find(
                    (element) => element.id === ele.ticketNatureOfIssue
                  );
                }
              });
              let finalArr: any = new Set();
              let first = [...data];
              first = first
                .filter(
                  (ele) =>
                    ele.plannedEndDate < new Date() ||
                    ele.plannedEndDate === new Date()
                )
                .sort((a, b) => a.plannedEndDate - b.plannedEndDate);
              let second = [...data];
              second = second
                .filter(
                  (ele) =>
                    ele.plannedStartDate < new Date() ||
                    ele.plannedStartDate.toDateString() ===
                      new Date().toDateString()
                )
                .sort((a, b) => a.plannedStartDate - b.plannedStartDate);
              let third = [...data];
              third = third
                .filter((ele) => ele.plannedStartDate > new Date())
                .sort((a, b) => a.plannedStartDate - b.plannedStartDate);
              // third.forEach((element) => {
              //   if (element.rType === "Task") {
              //     // element.fStatus = 3;
              //     // // element.fnatureOfIssure = null;
              //     // // element.fLinkedTicket = null;
              //     // element.thoursSpent = "";
              //     // element.fRemarks = "";
              //   } else {
              //     element.fStatus = 3;
              //     element.fnatureOfIssure = null;
              //     element.fLinkedTicket = null;
              //     element.thoursSpent = "";
              //     element.fRemarks = "";
              //   }
              // });

              let groupedFutureDates = groupArrayOfObjects(
                third,
                "plannedStartDate"
              );

              groupedFutureDates = Object.values(groupedFutureDates);

              setFutureDates(groupedFutureDates);

              finalArr = new Set([...first, ...second]);
              finalArr = Array.from(finalArr);

              // finalArr.forEach((element) => {
              //   if (element.rType === "Task") {
              //     // element.fStatus = taskStatusDropdown.find(
              //     //   (ele) => ele.id === element.status
              //     // );
              //     // // element.fnatureOfIssure = null;
              //     // // element.fLinkedTicket = null;
              //     // element.thoursSpent = "";
              //     // element.fRemarks = "";
              //   } else {
              //     element.fStatus = ticketStatusDropdown.find(
              //       (ele) => ele.id === 6
              //     );
              //     element.ticketNatureOfIssue = natureOfIssueDropdown.find(
              //       (ele) => ele.value == element.ticketNatureOfIssue
              //     );
              //     element.fLinkedTicket = null;
              //     element.thoursSpent = "";
              //     element.fRemarks = "";
              //   }
              // });

              // Omkar P
              // setDashboardData(finalArr);
              finalArr.sort((a, b) => {
                const customPriority: Record<string, number> = {
                  "Not Started": 1,
                  "In Progress": 2,
                };

                const getStatusPriority = (status: string): number => {
                  return customPriority[status] ?? Number.MAX_SAFE_INTEGER;
                };

                const priorityA = getStatusPriority(a.status.value);
                const priorityB = getStatusPriority(b.status.value);

                return priorityA - priorityB;
              });

              setDashboardData(finalArr);
            }
          }
        })();
      }
  }, [
    ticketStatusDropdown,
    taskStatusDropdown,
    // natureOfIssueDropdown,
    // testcaseStatusDropdown,
    issueStatusDropdown, //added by Yawar on 27/07
  ]);

  useEffect(() => {
    if (dashboardData.length > 0) {
      {
        setTotalReportedHoursToday(
          dashboardData.reduce(
            (sum, data) => (sum = sum + data.todayHoursSpent),
            0
          )
        );
      }
    }
    //setBackDateStatus(false);
  }, [dashboardData]);

  const handleTextEvent = async (event: any) => {
    setDashboardData([]);
    setCurrentDate(event);
    if (event.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
      setBackDateStatus(false);
    } else {
      setBackDateStatus(true);
    }
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "resourceAllocated") {
      setResourceAllocated(event);
      setEmployeeChanged(true);
      setCurrentDate(new Date());
      setBackDateStatus(false);
      setDashboardData([]);
    }
  };

  const selectOnChangeForTC = async (event: any, fieldName: any) => {
    if (fieldName === "EngTC") {
      setEngValTc(event);
    }
    if (fieldName === "ReqTC") {
      setReqValTc(event);
    }
  };
  useEffect(() => {
    setReqValTc({ value: 0, label: "Select Requirement" });
    setTcDashData([]);
    (async () => {
      showLoader();
      const { data } = await APICall(getTestCasesDashboard, "POST", {
        EngagementId: engValTc.value,
        RequirementId: reqValTc.value,
        start: start, //sangam
      });

      if (data !== null && data.length > 0) {
        data.forEach((ele) => {
          ele.plannedStartDate = new Date(ele.plannedStartDate);
          ele.plannedEndDate = new Date(ele.plannedEndDate);

          ele.status = testcaseStatusDropdown.find(
            (element) => element.id === ele.status
          );
        });
        let finalArr: any = new Set();
        let first = [...data];
        first = first
          .filter(
            (ele) =>
              ele.plannedEndDate < new Date() ||
              ele.plannedEndDate === new Date()
          )
          .sort((a, b) => a.plannedEndDate - b.plannedEndDate);
        let second = [...data];
        second = second
          .filter(
            (ele) =>
              ele.plannedStartDate < new Date() ||
              ele.plannedStartDate.toDateString() === new Date().toDateString()
          )
          .sort((a, b) => a.plannedStartDate - b.plannedStartDate);
        let third = [...data];
        third = third
          .filter((ele) => ele.plannedStartDate > new Date())
          .sort((a, b) => a.plannedStartDate - b.plannedStartDate);

        let groupedFutureDates = groupArrayOfObjects(third, "plannedStartDate");

        groupedFutureDates = Object.values(groupedFutureDates);

        setFutureDates(groupedFutureDates);

        finalArr = new Set([...first, ...second]);
        finalArr = Array.from(finalArr);

        //  await setTotalCount(data[0].totalCount); //sangam
        //  await setCurrentDataLength(finalArr.length)//
        setTcDashData((prevArr) => [...prevArr, ...finalArr]); //sangam
      }
    })();

    (async () => {
      const { data } = await APICall(getRequirementForTestCases, "POST", {
        Id: engValTc.value,
      });
      if (data !== null && data.length > 0) {
        let req = data.map((element) => ({
          value: element.id,
          label: element.title,
        }));
        setReqDdForTc(req);
      }
      hideLoader();
    })();
  }, [engValTc]);

  useEffect(() => {
    // added by hetal
    (async () => {
      setRiskMitigationData([]);

      if (riskEngValue && riskEngValue.value) {
        // console.log(riskEngValue.value, "if===>");

        const { data } = await APICall(getRMforEngagement, "POST", {
          EmployeeId: EmployeeId,
          EngagementIdStr: String(riskEngValue.value) || "",
          Start: 0,
        });
        // console.log("data===>", data);
        if (data !== null && data.length > 0) {
          setRiskMitigationData(data);
        } else {
          setRiskMitigationData([]);
        }
        hideLoader();
      } else {
        const commaSeparatedValues = riskEngDropDownOptions
          .map((option) => option.value)
          .join(",");
        // console.log("else ==>", commaSeparatedValues);

        const { data } = await APICall(getRMforEngagement, "POST", {
          EmployeeId: EmployeeId,
          EngagementIdStr: commaSeparatedValues || "",
          Start: 0,
        });
        // console.log("data===>", data);
        if (data !== null && data.length > 0) {
          setRiskMitigationData(data);
        } else {
          setRiskMitigationData([]);
        }
        hideLoader();
      }
    })();
  }, [riskEngValue, riskEngDropDownOptions]);

  useEffect(() => {
    setTcDashData([]);
    (async () => {
      showLoader();
      const { data } = await APICall(getTestCasesDashboard, "POST", {
        EngagementId: engValTc.value,
        RequirementId: reqValTc.value,
        start: start,
      });
      if (data !== null && data.length > 0) {
        data.forEach((ele) => {
          ele.plannedStartDate = new Date(ele.plannedStartDate);
          ele.plannedEndDate = new Date(ele.plannedEndDate);

          ele.status = testcaseStatusDropdown.find(
            (element) => element.id === ele.status
          );
        });
        let finalArr: any = new Set();
        let first = [...data];
        first = first
          .filter(
            (ele) =>
              ele.plannedEndDate < new Date() ||
              ele.plannedEndDate === new Date()
          )
          .sort((a, b) => a.plannedEndDate - b.plannedEndDate);
        let second = [...data];
        second = second
          .filter(
            (ele) =>
              ele.plannedStartDate < new Date() ||
              ele.plannedStartDate.toDateString() === new Date().toDateString()
          )
          .sort((a, b) => a.plannedStartDate - b.plannedStartDate);
        let third = [...data];
        third = third
          .filter((ele) => ele.plannedStartDate > new Date())
          .sort((a, b) => a.plannedStartDate - b.plannedStartDate);

        let groupedFutureDates = groupArrayOfObjects(third, "plannedStartDate");

        groupedFutureDates = Object.values(groupedFutureDates);

        setFutureDates(groupedFutureDates);

        finalArr = new Set([...first, ...second]);
        finalArr = Array.from(finalArr);
        setTcDashData(finalArr);
      }
      hideLoader();
    })();
  }, [reqValTc]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="form-group datepickerInput">
              <label>Current Date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label=""
                  disabled={
                    RoleIdArray.includes("3") ||
                    RoleIdArray.includes("8") ||
                    RoleIdArray.includes("1") ||
                    RoleIdArray.includes("2")
                      ? false
                      : true
                  }
                  value={currentDate}
                  onChange={(e) => handleTextEvent(e)}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField
                      variant="standard"
                      {...params}
                      /*sangam -->*/ onKeyDown={(e) => e.preventDefault()}
                    />
                  )}
                  maxDate={new Date()}
                  minDate={
                    RoleIdArray.includes("3") || RoleIdArray.includes("8")
                      ? new Date(new Date().setDate(new Date().getDate() - 365))
                      : RoleIdArray.includes("1") || RoleIdArray.includes("2")
                      ? new Date(new Date().setDate(new Date().getDate() - 1))
                      : null
                  }
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport",
                        },
                      },
                    ],
                  }}
                />
              </LocalizationProvider>
            </div>
          </div>
          {employeeHide ? null : (
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Employee Selected <sup>*</sup>
                </label>
                <SelectForm
                  options={resourceAllocatedOptions}
                  placeholder="Select"
                  // isDisabled={RoleIdArray.includes("3") ? false : true}
                  value={resourceAllocated}
                  onChange={(event) =>
                    selectOnChange(event, "resourceAllocated")
                  }
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                  display={
                    RoleIdArray.includes("3") || RoleIdArray.includes("8")
                      ? "inline-block"
                      : "none"
                  }
                />
              </div>
            </div>
          )}
        </div>

        {dashboardData.length > 0 && (
          <div className="reported-hours">
            <h4>Total Reported hours</h4>
            <span>
              {totalReportedHoursToday} /{" "}
              {workdayList.includes("Saturday") ? 8.0 : 8.5}
            </span>
          </div>

          // <section className="reported-hours">
          //   <div className="p-2">
          //     <div className="col-lg-12 p-0">
          //       <span>Total Reported hours</span>
          //       <span className="float-right">
          //         {/* {dashboardData.map((data) => data.hoursSpent)} */}
          //         {totalReportedHoursToday}/
          //         {workdayList.includes("Saturday") ? 8.0 : 8.5}
          //         {/* {dashboardData.reduce(
          //           (sum, data) => (sum = sum + data.hoursAssigned),
          //           0
          //         )} */}
          //       </span>
          //     </div>
          //   </div>
          // </section>
        )}

        <div className="box_grid_inner">
          {dashboardData.length > 0
            ? dashboardData.map((data, index, arr) => {
                if (data.rType === "TestCaseIssue") {
                  return (
                    <div key={index}>
                      <Accordian4
                        TCstatusDropdown={issueStatusDropdown}
                        TCnatureOfIssueDropdown={tcnatureOfIssueDropdown}
                        data={data}
                        setDashboardData={setDashboardData}
                        totalReportedHoursToday={totalReportedHoursToday}
                        backdatedDate={currentDate}
                        backDatedStatus={backDateStatus}
                        resourceAllocate = {resourceAllocated}
                      />
                    </div>
                  );
                }
                if (data.rType === "Task") {
                  // This is task accordian component
                  return (
                    <div key={index}>
                      <Accordian2
                        statusDropdown={taskStatusDropdown}
                        data={data}
                        setDashboardData={setDashboardData}
                        totalReportedHoursToday={totalReportedHoursToday}
                        backdatedDate={currentDate}
                        backDatedStatus={backDateStatus}
                        currentDate={currentDate} //Omkar P
                        resourceAllocate={resourceAllocated}
                      />
                    </div>
                  );
                }
                if (data.rType === "Ticket") {
                  // This is ticket accordian component
                  return (
                    <div key={index}>
                      <Accordian3
                        statusDropdown={ticketStatusDropdown}
                        natureOfIssueDropdown={natureOfIssueDropdown}
                        data={data}
                        setDashboardData={setDashboardData}
                        totalReportedHoursToday={totalReportedHoursToday}
                        backdatedDate={currentDate}
                        backDatedStatus={backDateStatus}
                        ticketTypeDropDown={ticketTypeOptoins} //sangam
                        resourceAllocate = {resourceAllocated}
                      />
                    </div>
                  );
                }
              })
            : !getTaskTicketLabel(dashboardData) && (
                <h4 className="no_data">
                  No task, ticket or test case issue assigned!
                </h4>
              )}
        </div>

        {futureDates.length > 0 &&
          futureDates.map((data, index) => (
            <React.Fragment key={index}>
              <section className="date">
                <div className="p-2">
                  <div className="">
                    <span>
                      <i
                        className="fa fa-calendar-alt mr-1"
                        aria-hidden="true"
                      ></i>{" "}
                      {format(new Date(data[0].plannedStartDate), "dd-MMM-yy")}
                    </span>
                  </div>
                </div>
              </section>
              {
                /* {data.map((datax, index) => (
                                if(datax.rType === "Task"){
                                  return(
                                    <div key={index}></div>
                                  )
                                }
                                <div key={index}>
                
                                  {datax.rType === "Task" ? (
                                    <Accordian2
                                      statusDropdown={taskStatusDropdown}
                                      data={datax}
                                      setDashboardData={setDashboardData}
                                      totalReportedHoursToday={totalReportedHoursToday}
                                      futureDate
                                      backdatedDate={currentDate}
                                      backDatedStatus={backDateStatus}
                                    />
                                  ) : (
                                    <Accordian3
                                      statusDropdown={ticketStatusDropdown}
                                      natureOfIssueDropdown={natureOfIssueDropdown}
                                      data={datax}
                                      setDashboardData={setDashboardData}
                                      totalReportedHoursToday={totalReportedHoursToday}
                                      futureDate
                                      backdatedDate={currentDate}
                                      backDatedStatus={backDateStatus}
                                    />
                                  )}
                                </div>
                              ))} */
                data.map((datax, index) => {
                  if (datax.rType === "TestCaseIssue") {
                    return (
                      <div key={index}>
                        <Accordian4
                          TCstatusDropdown={issueStatusDropdown}
                          TCnatureOfIssueDropdown={tcnatureOfIssueDropdown}
                          data={datax}
                          setDashboardData={setDashboardData}
                          totalReportedHoursToday
                          backdatedDate={currentDate}
                          backDatedStatus={backDateStatus}
                          resourceAllocate = {resourceAllocated}
                        />
                      </div>
                    );
                  }
                  if (datax.rType === "Task") {
                    // This is task accordian component
                    //Omkar P
                    return (
                      <div key={index}>
                        <Accordian2
                          statusDropdown={taskStatusDropdown}
                          data={datax}
                          setDashboardData={setDashboardData}
                          totalReportedHoursToday={totalReportedHoursToday}
                          backdatedDate={currentDate}
                          backDatedStatus={backDateStatus}
                          currentDate={currentDate} //Omkar P
                          resourceAllocate={resourceAllocated}
                        />
                      </div>
                    );
                  }
                  if (datax.rType === "Ticket") {
                    // This is ticket accordian component
                    return (
                      <div key={index}>
                        <Accordian3
                          statusDropdown={ticketStatusDropdown}
                          natureOfIssueDropdown={natureOfIssueDropdown}
                          // data={data}
                          data={datax}
                          setDashboardData={setDashboardData}
                          totalReportedHoursToday={totalReportedHoursToday}
                          backdatedDate={currentDate}
                          backDatedStatus={backDateStatus}
                          ticketTypeDropDown={ticketTypeOptoins} //sangam
                          resourceAllocate = {resourceAllocated}
                        />
                      </div>
                    );
                  }
                })
              }
            </React.Fragment>
          ))}

        {/* By Yawar */}

        {/* Accordian 5 */}
        {engDdForTc.length > 0 && (
          <>
            <div className="reported-hours mt-3">
              <h4>Test Cases</h4>
            </div>
            {/* <section className="reported-hours" style={{ marginTop: "20px" }}>
              <div className="p-2">
                <div className="col-lg-12 p-0">
                  <span>Test Cases</span>
                </div>
              </div>
            </section> */}
            <div className="box_grid_inner">
              <div className="row">
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Engagement <sup>*</sup>
                    </label>
                    <SelectForm
                      options={engDdForTc}
                      placeholder={"Select Engagement"}
                      isDisabled={false}
                      value={engValTc}
                      onChange={(e) => {
                        selectOnChangeForTC(e, "EngTC");
                      }}
                      noIndicator={false} //added on 25-07
                      noSeparator={false}
                    />
                  </div>
                </div>
                {reqDdForTc.length > 0 && (
                  <>
                    <div className="col-lg-3 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          Requirement <sup>*</sup>
                        </label>
                        <SelectForm
                          options={reqDdForTc}
                          placeholder={"Select Requirement"}
                          isDisabled={false}
                          value={reqValTc}
                          onChange={(e) => {
                            selectOnChangeForTC(e, "ReqTC");
                          }}
                          noIndicator={false} //added on 25-07
                          noSeparator={false}
                        />
                      </div>
                    </div>
                    {reqValTc.value > 0 &&
                      (tcDashData.length > 0 ? (
                        tcDashData.map((data, index, arr) => {
                          return (
                            <div key={index}>
                              <Accordian5
                                TCnatureOfIssueDropdown={
                                  tcnatureOfIssueDropdown
                                }
                                statusDropdown={testcaseStatusDropdown}
                                data={data}
                                setDashboardData={setDashboardData}
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div className="p-3">
                          <h4 className="no_data">No test cases uploaded!</h4>
                        </div>
                      ))}
                  </>
                )}
              </div>
              <div className="row">
                {engDdForTc.length > 0 &&
                  reqValTc.value == 0 &&
                  tcDashData.length > 0 &&
                  tcDashData.map((data, index, arr) => {
                    return (
                      <div key={index}>
                        <Accordian5
                          TCnatureOfIssueDropdown={tcnatureOfIssueDropdown}
                          statusDropdown={testcaseStatusDropdown}
                          data={data}
                          setDashboardData={setDashboardData}
                        />
                      </div>
                    );
                  })}

                {tcDashData[0] &&
                  tcDashData[0].totalCount > tcDashData.length && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        color: "grey.500",
                        mt: 2,
                      }}
                    >
                      {
                        isLoading ? (
                          <CircularProgress
                            color="inherit"
                            size={20}
                            thickness={4}
                          />
                        ) : (
                          <button
                            //style={{ background: "#96c61c" }}
                            onClick={() => {
                              setIsLoading(true);
                              setLoadMore(true);
                            }}
                            className="btn btn-save ml-1"
                          >
                            Show More
                          </button>
                        )
                        //   <Button sx={{ m: 2 }} onClick={()=>{
                        //     setIsLoading(true);
                        //     setLoadMore(true);
                        //     }} >
                        //     Show More
                        //  </Button>
                      }
                    </Box>
                  )}

                {/* {isLoading &&
                  (<Box sx={{ display: 'flex' ,justifyContent: 'center', color: 'grey.500', mt: 2}}>
                      
                   </Box>)
                  } */}
              </div>
            </div>
          </>
        )}

        {riskEngDropDownOptions?.length > 0 && (
          <>
            <div className="reported-hours mt-3">
              <h4>Risk Mitigation</h4>
            </div>
            {/* <section className="reported-hours" style={{ marginTop: "20px" }}>
              <div className="p-2">
                <div className="col-lg-12 p-0">
                  <span>Risk Mitigation</span>
                </div>
              </div>
            </section> */}
            <div className="box_grid_inner">
              <div className="row">
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Engagement <sup>*</sup>
                    </label>
                    <SelectForm
                      options={riskEngDropDownOptions}
                      placeholder={"Select Engagement"}
                      isDisabled={false}
                      value={riskEngValue}
                      onChange={(e) => {
                        setRiskEngValue(e);
                      }}
                      noIndicator={false} //added on 25-07
                      noSeparator={false}
                    />
                  </div>
                </div>
                {riskMitigationData?.length > 0 ? (
                  riskMitigationData.map((data, index, arr) => {
                    return (
                      <div key={index}>
                        {riskEngValue && riskEngValue.value ? (
                          <Accordian6
                            selectedEngagement={riskEngValue.value}
                            data={data}
                          />
                        ) : (
                          <Accordian6
                            selectedEngagement={data.engagementId}
                            data={data}
                          />
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="p-3">
                    <h4 className="no_data">No risk mitigation assigned!</h4>
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        {/* {dashboardData.length > 0 && (
          <section className="reported-hours" style={{ marginTop: "20px" }}>
            {getTestCaseLabel(dashboardData) && (
              <div className="p-2">
                <div className="col-lg-12 p-0">
                  <span>Test Cases</span>
                </div>
              </div>
            )}
          </section>
        )}
        {getTestCaseLabel(dashboardData) && dashboardData.length > 0
          ? dashboardData.map((data, index, arr) => {
              if (data.rType === "TestCase") {
                // This is ticket accordian component
                return (
                  <div key={index}>
                    <Accordian5
                      TCnatureOfIssueDropdown={tcnatureOfIssueDropdown}
                      statusDropdown={testcaseStatusDropdown}
                      data={data}
                      setDashboardData={setDashboardData}
                    />
                  </div>
                );
              }
            })
          : getTestCaseLabel(dashboardData) && <h3>No TestCases Uploaded!</h3>} */}
        {/* {TaskListArrayData[0].ticketList.map((taskList, index) => {
          return (
            <div key={index}>
              <Accordian data={taskList} />
            </div>
          );
        })} 
         */}
        <Bubble />
      </div>
    </>
  );
}

export default Homescreen;
function setTotalHours(hours: any) {
  throw new Error("Function not implemented.");
}
